import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=13e12abd&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=ts&"
export * from "./Table.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=13e12abd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e12abd",
  null
  
)

export default component.exports